import { render, staticRenderFns } from "./TableColumns.vue?vue&type=template&id=3f1388d4&scoped=true&"
import script from "./TableColumns.vue?vue&type=script&setup=true&lang=ts&"
export * from "./TableColumns.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./TableColumns.vue?vue&type=style&index=0&id=3f1388d4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1388d4",
  null
  
)

export default component.exports